// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const resetConfirmationModal = () => ({
    type: actions.RESET_CLAIM_PARTS_CONFIRMATION_MODAL
});

export const setConfirmationModal = options => ({
    data: options,
    type: actions.SET_CLAIM_PARTS_CONFIRMATION_MODAL
});



// WEBPACK FOOTER //
// ./src/claim/parts/action-creators/confirmation-modal.js